import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 0C4.9 0 0 4.79 0 10.753s4.9 10.754 11 10.754 11-4.79 11-10.754S17.1 0 11 0m0 19.551c-5 0-9-3.91-9-8.798s4-8.798 9-8.798 9 3.91 9 8.798-4 8.798-9 8.798m1.2-14.468c-2.1-.684-4.4.391-5.1 2.346-.1.587.1 1.173.7 1.271.5.196 1.1-.098 1.3-.586.4-.978 1.5-1.565 2.6-1.173.8.293 1.3.977 1.3 1.857 0 .977-1.7 1.76-2.3 2.053-.5.195-.8.684-.6 1.27.1.392.5.685.9.685.1 0 .2 0 .3-.098.4-.098 3.7-1.27 3.7-3.812-.1-1.76-1.2-3.226-2.8-3.813m-1.9 9.874c-.2.195-.3.39-.3.684 0 .293.1.489.3.684s.4.294.7.294.5-.098.7-.294.3-.489.3-.684-.1-.489-.3-.684a.98.98 0 0 0-1.4 0"
    }, null, -1)
  ]))]))
}
export default { render: render }